/**
 * addContentFlowPredicates
 *
 * Pure `AddContentFlowType` predicates shared by `AddContentSheetContent` (step
 * list) and `useExpauseLocalizations.getAddContentStepTitles` (step titles), so
 * the flow-set membership that drives BOTH sites has a single owner — a flow
 * added to one site but not the other would otherwise render five steps with
 * two titles.
 *
 * Lives in `domain/utils/` rather than beside its callers: it is a pure
 * predicate over the `AddContentFlowType` domain enum with no presentation
 * dependency, and one of its consumers is the globally-imported locale module
 * (`presentation/locale/expauseLocalizations.ts`), which must not reach into a
 * feature folder.
 */

import { AddContentFlowType } from '@/domain/enums/publish/addContentFlowType';

/**
 * Chat + community + feedback + profileImage are the trimmed "message media"
 * flows: Drop + Preview only, "Done" primary action, no monetization overlays.
 * Feedback and profileImage are image-only and their "Done" collects the pick
 * rather than sending it (see `useAddContentSubmitSeams`).
 *
 * The comment-reply flow is deliberately NOT a member — it runs the full
 * five-step user chain and only swaps the step-1 title
 * (`getAddContentStepTitles`).
 */
export function isMessageFlowType(flowType: AddContentFlowType): boolean {
  return (
    flowType === AddContentFlowType.chat
    || flowType === AddContentFlowType.community
    || flowType === AddContentFlowType.feedback
    || flowType === AddContentFlowType.profileImage
  );
}
